export const toGlobalId = (model: string, id: number | string): string => {
  const label = `${model}:${id}`;
  if (typeof window === "undefined" || typeof btoa === "undefined") {
    return Buffer.from(label).toString("base64");
  }

  return window.btoa(label);
};
